<template>
    <el-col :md="10" :class="classes">
        <el-form-item class="item-fome-base"  v-bind:class="{'required': required === true}" :label="label">
            <el-select 
                class="w--10 bg-gray-item" 
                :placeholder="placeholder || '選択してください'"
                :value="value" 
                @change="onChangeHanlder"
                :multiple="multiple"
                :disabled="disabled"
            >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />

            </el-select>
            <div class="text-left">
                <label v-if="error" class="text-danger text-left"> {{ error.msg }} </label>
            </div>
        </el-form-item>
    </el-col>
</template>

<script>
export default {
    props: [
        "error",
        "required",
        "value",
        "field",
        "options",
        "classes",
        "label",
        "placeholder",
        "multiple",
        "onChange",
        "disabled"
    ],
    mounted(){
    },
    methods: {
        onChangeHanlder(itemsSelected){
            const {multiple} = this;
            this.$emit('change', itemsSelected)
            if( multiple && itemsSelected.indexOf(' ')> -1 ){
                this.$emit('input', [])
                return
            }
            this.$emit('input', itemsSelected)
        },
        updateValue(val) {
            if( this.multiple && val===' '){
                val=[]
            }
            this.$emit('input', val)
        }
    },
}
</script>